<template>
    <div>

        <div v-if="loading" class="text-center"><img src="/loading.svg" /><p>Loading...</p></div>
        <div v-else>
            <div v-if="displayFinish" class="text-center">
                <h1 class="my-4">You did it!</h1>
                <img src="/img/celebration.gif" style="border-radius: 2rem; margin-bottom: 1.5em;" />
                <p>Thanks for your purchase! Please refresh the page to see the effects.</p>
            </div>

            <div v-if="displayNewLicenseCode">
                <h1 class="my-4">We combined your licenses into 1 code</h1>
                <p>We've combined all your provided codes into one master license code:</p>
                <p class="text-left mx-auto p-3 font-weight-bold" style="max-width: 500px; border-radius: 16px; background-color: #f2f4f7;">
                    {{newLicenseCode}}
                </p>
                <p>Keep it safe! Use this master code for all future projects or portals.<br><br>
                    To redeem, just enter this master code and select the option to redeem one license code.</p>
                <b-button variant="primary" class="mt-3" @click="gotoFinish()">Next <i class="fa fa-arrow-right"></i></b-button>
            </div>

            <b-button variant="primary" v-if="!isFormOpen && !displayFinish && !displayNewLicenseCode" @click="isFormOpen = true">Add more license(s)</b-button>

            <div v-if="isFormOpen">
                <div v-if="licenses.length === 0">
                    <p>How many licenses do you want to add?</p>
                    <b-button @click="setNumberLicenses(1)">1</b-button>
                    <b-button @click="setNumberLicenses(2)">2</b-button>
                    <b-button @click="setNumberLicenses(3)">3</b-button>
                    <b-button @click="setNumberLicenses(4)">4</b-button>
                    <b-button @click="setNumberLicenses(5)">5</b-button>
                    <p class="small mt-2">If you have multiple project, please always stack codes on the original project.</p>
                </div>
                <div v-else>
                    <validation-observer ref="observer" v-slot="{ passes }">
                        <form @submit.stop.prevent="passes(signup)">
                            <p>Enter your license code(s) here:</p>
                            <b-alert show variant="danger" v-if="license_error" v-html="license_error"></b-alert>
                            <template v-for="license in licenses">
                                <validation-provider :name="license_code_name" rules="required|license_code" v-slot="{ errors }">
                                    <b-form-input class="mt-1" type="text" v-model="license.key" placeholder="license_3726cf2c..."></b-form-input>
                                    <span class="validation">{{ errors[0] }}</span>
                                </validation-provider>
                            </template>

                            <button type="submit" class="btn btn-success  mt-5">Finish <i class="fa fa-arrow-right"></i></button>
                        </form>
                    </validation-observer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationPop from '../mixins/NotificationPop.js'

export default {
    name: "StackMoreCodes",
    mixins: [NotificationPop],
    components: {
    },

    data() {
        return {
            loading: true,
            isFormOpen: false,
            license_code_name: 'AppSumo Code',
            license_error: null,
            displayNewLicenseCode: false,
            newLicenseCode: null,
            displayFinish: false,


            licenses: [],
        }
    },

    async created() {
        this.loading = false;
    },
    methods: {
        /**
         * Set number of expected licenses
         * @param number
         */
        setNumberLicenses: function (number) {
            for (let i = 0; i < number; i++) {
                this.licenses.push({type: 'add'});
            }
        },

        /**
         * Show finish
         */
        gotoFinish: function () {
            this.displayFinish = true
            this.displayNewLicenseCode = false

            this.$confetti.start({
                particles: [
                    {
                        type: 'heart',
                        size: 14,
                    }
                ],
            });
            setTimeout(() => this.$confetti.stop(), 2000);
        },

        /**
         * Create the new portal
         */
        signup: function () {
            this.isFormOpen = false;
            this.loading = true;
            this.license_error = null; // reset

            this.$http.post('/api/stack_licenses',{
                licenses: this.licenses,
            })
                .then(({data}) => {
                    this.loading = false

                    if(data.new_license_code) {
                        this.displayNewLicenseCode = true
                        this.newLicenseCode = data.new_license_code
                    } else {
                        this.gotoFinish()
                    }
                    this.popNotification('Hooray 🥳 <br>License code(s) successfully added!', 'success')
                })
                .catch(error => {
                    this.isFormOpen = true;
                    this.loading = false

                    if(error.response.data.message === 'license_replaced') {
                        this.license_error = 'License (<i>'+error.response.data.old+'</i>) has been replaced by a master one:<br><br> <b>' + error.response.data.key + '</b> <br><br>Please use the master license for activation. <br><small>Note: When you add multiple licenses, we consolidate them into a single, master license for easier management.</small>';
                    }

                    if(error.response.data.message === 'license_not_found') {
                        this.license_error = 'Sorry, we are not able to find this license: <br>' + error.response.data.key + '.<br><br> Try again or contact support.';
                    }

                    if(error.response.data.message === 'error_with_master') {
                        this.license_error = 'Sorry, we are not able to redeem your licenses because of an error in your account. Please contact support.';
                    }

                    if(error.response.data.message === 'license_already_applied') {
                        this.license_error = 'You have already applied this license on the current account.';
                    }

                    // handle authentication and validation errors here
                    console.log(error.response)
                    this.popNotification('Could not activate license', 'danger')
                })
        },


    }
}
</script>